define('taoQtiItem/qtiXmlRenderer/renderers/interactions/SelectPointInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'selectPointInteraction',
        template : tpl
    };
});
